export const PROFILE_UPDATE_REQUEST = 'PROFILE_UPDATE_REQUEST';
export const PROFILE_UPDATE_SUCCESS = 'PROFILE_UPDATE_SUCCESS';
export const PROFILE_UPDATE_ERROR = 'PROFILE_UPDATE_ERROR';

export const profileUpdateRequest = user => {
  return {
    user,
    type: PROFILE_UPDATE_REQUEST,
  };
};

export const profileUpdateSuccess = user => ({
  type: PROFILE_UPDATE_SUCCESS,
  user,
});

export const profileUpdateError = error => ({
  error,
  type: PROFILE_UPDATE_ERROR,
});

export const CREATE_SMS_SUBSCRIPTION_REQUEST =
  'CREATE_SMS_SUBSCRIPTION_REQUEST';
export const CREATE_SMS_SUBSCRIPTION_SUCCESS =
  'CREATE_SMS_SUBSCRIPTION_SUCCESS';
export const CREATE_SMS_SUBSCRIPTION_ERROR = 'CREATE_SMS_SUBSCRIPTION_ERROR';

export const createSmsSubscriptionRequest = () => ({
  type: CREATE_SMS_SUBSCRIPTION_REQUEST,
});

export const createSmsSubscriptionSuccess = smsSubscription => ({
  type: CREATE_SMS_SUBSCRIPTION_SUCCESS,
  smsSubscription,
});

export const createSmsSubscriptionError = error => ({
  error,
  type: CREATE_SMS_SUBSCRIPTION_ERROR,
});

export const SMS_SUBSCRIPTION_FORM_LOAD = 'SMS_SUBSCRIPTION_FORM_LOAD';
export const smsSubscriptionFormLoad = phone => ({
  phone,
  type: SMS_SUBSCRIPTION_FORM_LOAD,
});



// WEBPACK FOOTER //
// ./app/javascript/apps/sms_subscriptions/actions.js